<script setup>
  import ClaimsChartComponent from "@/Components/ClaimsChart/ClaimsChartComponent.vue";
  import TasksNewChartComponent from "@/Components/TasksNewChart/TasksNewChartComponent.vue";
  import TasksCompletedChartComponent from "@/Components/TasksCompletedChart/TasksCompletedChartComponent.vue";
  import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid>
    <v-row v-if="Permissions.checkPermissions(['charts.claims'])">
      <v-col cols="12">
        <ClaimsChartComponent/>
      </v-col>
    </v-row>

      <v-row>
        <v-col cols="6" v-if="Permissions.checkPermissions(['charts.tasks-due'])">
          <TasksNewChartComponent/>
        </v-col>
        <v-col cols="6" v-if="Permissions.checkPermissions(['charts.tasks-completed'])">
          <TasksCompletedChartComponent/>
        </v-col>
      </v-row>


  </v-container>
</template>